export default {
    type: {
        "ac_router": "Hai raggiunto il limite di ordinazione dei router AC",
        "chair": "Hai raggiunto il limite di sedie ordinabili",
        "default": "Hai raggiunto il limite di ordinazione",
        "default_multiple": "Hai raggiunto il limite di ordinazione di prodotti simili",
        "desk": "Hai raggiunto il limite di ordinazione delle scrivanie",
        "desktop": "Hai raggiunto il limite di ordinazione del desktop",
        "desktop_riser": "Hai raggiunto il limite di ordinazione dei supporti da scrivania",
        "detector": "Hai raggiunto il limite di ordinazione di rilevatori di fumo e rumore",
        "displayport_cable": "Hai raggiunto il limite di ordinazione dei cavi DisplayPort",
        "docking station": "Hai raggiunto il limite di ordinazione delle docking station",
        "dual_usb_adapter": "Hai raggiunto il limite di ordinazione degli adattatori USB dual band",
        "ear cushion": "Hai raggiunto il limite di ordinazione dei cuscinetti auricolari",
        "footrest": "Hai raggiunto il limite di ordinazione dei poggiapiedi",
        "hdmi_cable": "Hai raggiunto il limite di ordinazione dei cavi HDMI",
        "hdmi_displayport_cable": "Hai raggiunto il limite di ordinazione dei cavi HDMI-DisplayPort",
        "hdmi_vga_cable": "Hai raggiunto il limite di ordinazione dei cavi HDMI-VGA",
        "headset": "Hai raggiunto il limite di ordinazione dei dispositivi audio",
        "keyboard": "Hai raggiunto il limite di ordinazione delle tastiere",
        "kvm switch": "Hai raggiunto il limite di ordinazione degli switch KVM",
        "kvm_switch": "Hai raggiunto il limite di ordinazione degli switch KVM",
        "lamp": "Hai raggiunto il limite di ordinazione delle lampade",
        "laptop stand": "Hai raggiunto il limite di ordinazione dei supporti per laptop",
        "laptop": "Hai raggiunto il limite di ordinazione dei laptop",
        "mesh_router": "Hai raggiunto il limite di ordinazione dei router mesh",
        "monitor": "Hai raggiunto il limite di ordinazione dei monitor",
        "mouse": "Hai raggiunto il limite di topi ordinabili",
        "patch_cord": "Hai raggiunto il limite di ordinazione dei cavi patch Cat6",
        "power": "Hai raggiunto il limite di ordinazione dei cavi di alimentazione",
        "power_center": "Hai raggiunto il limite di ordinazione dei Power Center",
        "power_strip": "Hai raggiunto il limite di ordinazione delle ciabatte",
        "printer": "Hai raggiunto il limite di ordinazione delle stampanti",
        "smart_plug": "Hai raggiunto il limite di ordinazione delle mini prese intelligenti",
        "smart_power_strip": "Hai raggiunto il limite di ordinazione delle ciabatte intelligenti",
        "speakerphone": "Hai raggiunto il limite di ordini di vivavoce",
        "stylus": "Hai raggiunto il limite di ordinazione degli stilo",
        "tablet": "Hai raggiunto il limite di ordinazione delle compresse",
        "tablet accessory": "Hai raggiunto il limite di ordinazione degli accessori per tablet",
        "thunderbolt_cable": "Hai raggiunto il limite di ordinazione di USB-C a Thunderbolt",
        "travel_router": "Hai raggiunto il limite di ordinazione dei router di viaggio",
        "usb hub": "Hai raggiunto il limite di ordinazione degli hub USB",
        "usb_adapter": "Hai raggiunto il limite di ordinazione degli adattatori USB",
        "usb_hub": "Hai raggiunto il limite di ordinazione degli hub USB",
        "webcam": "Hai raggiunto il limite di ordinazione delle webcam"
    }
}